import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import PolyLoader from '../_components/PolyLoader';
import {
  Row,
  Col,
  Card,
  Button,
  CardHeader,
  CardBody,
} from "shards-react";
import axios from 'axios';
import Cookies from "universal-cookie";
import PageTitle from "../_components/PageTitle";

const cookies = new Cookies();

const ConsultasMicrositeView = props => {
  const [loading, setLoading] = useState(true);
  const [notAllowed, setNotAllowed] = useState(false);
  const [consulta, setConsulta] = useState(null);

  useEffect(() => {
    dataget();
  }, []);

  useEffect(() => {
    dataget();
  }, [props.match.params.id]);

  function dataget() {
    setLoading(true);
    axios.get(
      'https://nuestrosautos.cca.org.ar/api/dealer/' +
      cookies.get("dealer").id +
      '/microsite-questions/' +
      props.match.params.id +
      "?token=" + props.user.token
    ).then(response => {
      if (response.data && response.data.status === 'ok') {
        setConsulta(response.data.data);
        setNotAllowed(false);
      } else {
        setNotAllowed(true);
      }
      setLoading(false);
    }).catch(() => {
      setNotAllowed(true);
      setLoading(false);
    });
  }

  if (loading) {
    return <PolyLoader open={true} text="Cargando"></PolyLoader>;
  }

  if (notAllowed || !consulta) {
    return (
      <div>
        <Row noGutters className="page-header py-4" style={{ width: "100%" }}>
          <PageTitle sm="6" title="No se puede acceder a la consulta" className="text-sm-left" />
        </Row>
        <p>No se encontró la consulta o no tenés permisos para verla. Cambiá de concesionaria o contactá a soporte.</p>
      </div>
    );
  }

  // Preparo links para responder
  const whatsappLink = consulta.telefono
    ? 'https://wa.me/' + String(consulta.telefono).replace(/\D/g, '') +
      '?text=' + encodeURIComponent('Hola ' + (consulta.nombre || '') + ', te contacto desde ' + (consulta.vehicle ? 'la consulta del ' + consulta.vehicle.title : 'nuestro sitio web') + '.')
    : null;
  const mailLink = consulta.email ? 'mailto:' + consulta.email : null;

  return (
    <div>
      <Row noGutters className="page-header py-4" style={{ width: "100%" }}>
        <PageTitle sm="6" title="Consulta desde el sitio web" className="text-sm-left" />
      </Row>

      <Row>
        <Col sm="8">
          <Card small className="card-post mb-4 mt-2">
            <CardHeader>
              <h4 className="card-title text-capitalize">
                Mensaje de {consulta.nombre}
              </h4>
            </CardHeader>
            <CardBody>
              <div className="chabox">
                <div className="chat_wrapper">
                  <p className="card_message_1" style={{ whiteSpace: 'pre-wrap' }}>
                    {consulta.comentario || '(Sin mensaje)'}
                  </p>
                </div>
              </div>

              <Row className="mt-4">
                <Col sm="6">
                  {whatsappLink && (
                    <Button
                      className="w-100 mb-2"
                      theme="success"
                      href={whatsappLink}
                      target="_blank"
                    >
                      <i className="material-icons" style={{ fontSize: '18px', verticalAlign: 'middle' }}>chat</i>
                      {' '}Responder por WhatsApp
                    </Button>
                  )}
                </Col>
                <Col sm="6">
                  {mailLink && (
                    <Button
                      className="w-100 mb-2"
                      theme="primary"
                      href={mailLink}
                    >
                      <i className="material-icons" style={{ fontSize: '18px', verticalAlign: 'middle' }}>mail</i>
                      {' '}Responder por Email
                    </Button>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

        <Col sm="4">
          <Card small className="card-post mb-4 mt-2">
            <CardHeader>
              <h4 className="card-title">Información</h4>
            </CardHeader>
            <CardBody className="border-top">
              <div>
                <p className="t-2 pt-1 mb-0 text-left">Plataforma</p>
                <p className="t-1 text-left">
                  <a
                    href={'https://' + consulta.microsite_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {consulta.microsite_url}
                  </a>
                </p>
              </div>
              <div>
                <p className="t-2 pt-1 mb-0 text-left">Nombre</p>
                <p className="t-1 text-left">{consulta.nombre}</p>
              </div>
              <div>
                <p className="t-2 pt-1 mb-0 text-left">Email</p>
                <p className="t-1 text-left">{consulta.email}</p>
              </div>
              <div>
                <p className="t-2 pt-1 mb-0 text-left">Teléfono / WhatsApp</p>
                <p className="t-1 text-left">{consulta.telefono}</p>
              </div>
              <div>
                <p className="t-2 pt-1 mb-0 text-left">Fecha</p>
                <p className="t-1 text-left">{consulta.created_at}</p>
              </div>
            </CardBody>
          </Card>

          <Card small className="card-post mb-3 mt-2">
            <CardHeader>
              <h4 className="card-title">Vehículo</h4>
            </CardHeader>
            <CardBody className="border-top">
              {consulta.vehicle ? (
                <Row>
                  <Col sm="4">
                    {consulta.vehicle.image && (
                      <img className="rounded w-100" src={consulta.vehicle.image} alt={consulta.vehicle.title} />
                    )}
                  </Col>
                  <Col sm="8">
                    <p className="t-2 pt-1 mb-0 text-left">{consulta.vehicle.title}</p>
                    <p className="t-1 text-left mb-1">Año {consulta.vehicle.year}</p>
                    <p className="t-1 text-left">$ {consulta.vehicle.price}</p>
                  </Col>
                </Row>
              ) : (
                <p className="t-1 text-left">Consulta general del sitio (sin vehículo asociado)</p>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

function mapState(state) {
  const { authentication } = state;
  const { user } = authentication;
  return { user, initialValues: {} };
}

const po = reduxForm({
  form: 'ConsultasMicrositeView',
  enableReinitialize: true,
})(ConsultasMicrositeView);

const pox = connect(mapState, {})(po);

export { pox as ConsultasMicrositeView };
